import { render, staticRenderFns } from "./AppButtonPlus.vue?vue&type=template&id=7405dbe0"
import script from "./AppButtonPlus.vue?vue&type=script&lang=js"
export * from "./AppButtonPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports